import styled, { css } from "styled-components";
import { IMobileMenuStyleProps } from "./interfaces";

export const MobileMenu = styled.div<IMobileMenuStyleProps>`
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    height: 0;
    color: ${p => p.theme.c.dark};
    transition: height 400ms;
    background-color: ${p => p.theme.c.boost};
    box-shadow: 0 0 3px 0 ${p => p.theme.c.dark} inset;
    overflow: hidden;
    ${p =>
        p.show &&
        css`
            height: 100vh;
        `}
    ${p =>
        !p.show &&
        css`
            pointer-events: none;
        `}
`;

export const StyledMenuItem = styled.div`
    font-size: 18px;

    a {
        padding: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    a span {
        line-height: 28px;
    }

    svg,
    [class^="i-"] {
        fill: ${p => p.theme.c.dark};
        color: ${p => p.theme.c.dark};
        margin: 0 9px;
        width: 28px;
        height: 28px;
        font-size: 28px;
    }

    .Active {
        color: ${p => p.theme.c.white};
        svg,
        [class^="i-"] {
            fill: ${p => p.theme.c.white};
            color: ${p => p.theme.c.white};
        }
    }
`;